export default __webpack_public_path__ + "static/media/Slide-5.8760bab6.png";